// extracted by mini-css-extract-plugin
export default {"TagTooltip-tag-button":"TagTooltip-tag-button3cBXYBcMrKlM","TagTooltip-tag-button_inline":"TagTooltip-tag-button_inline3kZK7Qmy_BxH"};